export enum BulkMasterListMode {
  ADD_ALL = "add-all",
  REMOVE_ALL = "remove-all",
  MIXED = "mixed"
}

export type BulkMasterListState = {
  label: string;
  mode: BulkMasterListMode;
};